import { useSelector } from 'react-redux';
import { tasksSelector } from 'entities/task/model/slice/taskSlice';

export const useTaskCard = (id: string) => {
    const task = useSelector((state) => tasksSelector.selectById(state, id));

    return { task };
};
